<script>
    import { push, location } from "svelte-spa-router";
    import { createEventDispatcher, onMount } from "svelte";
    import { Preferences } from "@capacitor/preferences";
    import { dbInfo, loadDbInfo } from "../stores/dbTarget.js";
    export let activeMenu = "";

    const dispatch = createEventDispatcher();
    let tbt_menu_at = "N";

    onMount(async () => {
        try {
            const { value } = await Preferences.get({ key: "retechInfo" });
            if (value) {
                const userData = JSON.parse(value);
                const rawTbt = userData.tbt_menu_at;
                if (rawTbt) {
                    tbt_menu_at = String(rawTbt).trim().toUpperCase();
                } else if (userData.login_id === "admin") {
                    tbt_menu_at = "A";
                } else {
                    tbt_menu_at = "N";
                }
            }
        } catch (e) {
            tbt_menu_at = "N";
        }

        // 새로고침 등으로 접속 DB 정보가 아직 없으면 조회
        if (!$dbInfo.loaded) loadDbInfo();
    });

    const menus = [
        { name: "MENU", path: "/Menu", category: "all" },
        { name: "공정검사성적서관리", path: "/ProcessInspection", category: "basic" },
        { name: "공정부적합조치관리", path: "/ProcessNonconformity", category: "basic" },
        { name: "최종검사성적서관리", path: "/FinalInspection", category: "basic" },
        { name: "최종부적합조치관리", path: "/FinalNonconformity", category: "basic" },
        { name: "출하등록관리", path: "/Shipment", category: "basic" },
        { name: "공급계획(PSI)", path: "/SupplyPlan", category: "management" },
        { name: "매출현황", path: "/SalesStatus", category: "management" },
    ];

    $: visibleMenus = menus.filter((m) => {
        if (m.category === "all") return true;
        if (tbt_menu_at === "A") return true; // 전체
        if (tbt_menu_at === "Y") return m.category === "management"; // 경영정보
        return m.category === "basic"; // 기본메뉴 ('N' 및 기본값)
    });

    // 💡 초기화 클릭 시 즉시 부모에게 이벤트 전달
    function handleReset() {
        dispatch("reset");
    }

    function handleNavWheel(e) {
        if (e.deltaY !== 0 && !e.deltaX) {
            e.currentTarget.scrollLeft += e.deltaY;
        }
    }
</script>

<nav class="global-nav">
    <div class="nav-left" on:click={() => push("/")}>
        🏠 {$dbInfo.companyName || "리텍(주)"}
        {#if $dbInfo.code === "T"}<span class="nav-env-badge">테스트 DB</span>{/if}
    </div>
    <div class="nav-menu" on:wheel={handleNavWheel}>
        {#each visibleMenus as menu}
            <button
                class="nav-item"
                class:active={$location === menu.path ||
                    activeMenu === menu.name}
                on:click={() => {
                    if ($location === menu.path) {
                        dispatch("menuReset");
                    } else {
                        push(menu.path);
                    }
                }}
            >
                {menu.name}
            </button>
        {/each}
    </div>

    <div class="nav-right">
        <button class="nav-reset-btn" on:click={handleReset}>
            <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <path d="M3 3v5h5" />
            </svg>
            초기화
        </button>
    </div>
</nav>

<style>
    .global-nav {
        background: #1e293b;
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        height: 50px;
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 1000;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }
    .nav-env-badge {
        display: inline-block;
        margin-left: 6px;
        padding: 1px 7px;
        border-radius: 5px;
        background: #f97316;
        color: white;
        font-size: 0.65rem;
        font-weight: 800;
        vertical-align: middle;
    }
    .nav-left {
        font-weight: 900;
        font-size: 1.2rem;
        cursor: pointer;
        color: #3b82f6;
        white-space: nowrap;
        flex-shrink: 0;
    }
    .nav-menu {
        display: flex;
        flex: 1;
        min-width: 0;
        margin: 0 16px;
        gap: 2px;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
        -webkit-overflow-scrolling: touch;
    }
    .nav-menu::-webkit-scrollbar {
        height: 3px;
    }
    .nav-menu::-webkit-scrollbar-track {
        background: transparent;
    }
    .nav-menu::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.25);
        border-radius: 4px;
    }
    .nav-menu::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.45);
    }
    .nav-item {
        background: none;
        border: none;
        color: #94a3b8;
        padding: 0 14px;
        cursor: pointer;
        font-weight: 700;
        height: 100%;
        transition: 0.2s;
        white-space: nowrap;
        font-size: 0.9rem;
        position: relative;
        flex-shrink: 0;
    }
    .nav-item.active {
        color: #ffffff;
        background: rgba(59, 130, 246, 0.15);
    }
    .nav-item.active::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: #3b82f6;
    }

    .nav-right {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }
    .nav-reset-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #334155;
        color: #e2e8f0;
        border: 1.5px solid #475569;
        padding: 7px 14px;
        border-radius: 6px;
        font-size: 0.85rem;
        font-weight: 800;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;
    }
    .nav-reset-btn:hover {
        background: #475569;
        border-color: #3b82f6;
        color: white;
    }
</style>
